import { ConfidenceLevel } from "@teaming/common-enums";

export default {
	// Brad Meyer changed the confidence level of this goal from Medium to High.
	text: "{changedBy} changed the confidence level of this goal from {previousConfidenceLevel} to {currentConfidenceLevel}.",

	[ `confidence${ ConfidenceLevel.HIGH }` ]: "High",
	[ `confidence${ ConfidenceLevel.MEDIUM }` ]: "Medium",
	[ `confidence${ ConfidenceLevel.LOW }` ]: "Low",
};
